import { isPersistedPrimaryMergedTable } from 'restaurantAdmin/floorPlans/utils';
import type { SplitMergeState } from './splitMergeTablesReducer';

export const canUndoMerge = (state: SplitMergeState): boolean =>
  state.mergedTables.length > 0 &&
  state.selectedTables.length === 1 &&
  state.mergedTables
    .map((mergedTable) => mergedTable.primaryMergeTableId)
    .includes(state.selectedTables[0].id);

export const isMergeable = (state: SplitMergeState): boolean =>
  state.selectedTables.length > 1;

export const isUnmergeable = (state: SplitMergeState): boolean =>
  state.selectedTables.length === 1 &&
  isPersistedPrimaryMergedTable(state.selectedTables[0]) &&
  state.mergedTables.length === 0;

export const isReadyToPersistMerge = (state: SplitMergeState): boolean =>
  state.mergedTables.length > 0 || state.unMergedTableIds.length > 0;

export const isStagedPrimaryMergedTableId =
  (state: SplitMergeState) => (tableId: string) =>
    state.mergedTables.some(
      ({ primaryMergeTableId }) => primaryMergeTableId === tableId,
    );

export const isStagedForUnmerge =
  (state: SplitMergeState) => (tableId: string) =>
    state.unMergedTableIds.includes(tableId);

export const isSelectedForMerge =
  (state: SplitMergeState) =>
  (tableId: string): boolean =>
    !!state.selectedTables.find((table) => table.id === tableId);

export const isStagedSecondaryMergedTableId =
  (state: SplitMergeState) => (tableId: string) =>
    state.mergedTables
      .flatMap((mergedTable) => mergedTable.secondaryMergeTableIds)
      .includes(tableId);
